import { LayoutModule } from '@angular/cdk/layout';
import { CdkColumnDef } from '@angular/cdk/table';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { ConditionsComponent } from './components/conditions/conditions.component';
import { ConditionsParkingSizeComponent } from './components/conditionsparkingsize/conditionsparkingsize.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DebugModalComponent } from './components/debugmodal/debugmodal.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { MySettingsComponent } from './components/my-settings/my-settings.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { AppInfoComponent } from './components/qr-scanner/app-info/app-info.component';
import { InfoDialogComponent } from './components/qr-scanner/info-dialog/info-dialog.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CdkDetailRowDirective } from './directives/cdk-detail-row.directive';
import { DatepickerDirective } from './directives/datepicker.directive';
import { AuthGuard } from './guards/auth.guard';
import { CheckoutPageComponent } from './home/checkout/checkout-page/checkout-page.component';
import { PaymentBottomsheetComponent } from './home/checkout/payment-bottomsheet/payment-bottomsheet.component';
import { PaymentFailureComponent } from './home/checkout/payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './home/checkout/payment-success/payment-success.component';
import { ReceiptComponent } from './home/checkout/receipt/receipt.component';
import { ActivateUserComponent } from './home/admin/users/activate-user/activate-user.component';
import { AddUserComponent } from './home/admin/users/add-user/add-user.component';
import { ConfirmDeleteComponent } from './home/admin/users/edit-user/confirm-delete/confirm-delete.component';
import { EditUserComponent } from './home/admin/users/edit-user/edit-user.component';
import { UsersListComponent } from './home/admin/users/users-list/users-list.component';
import { MdToHtmlPipe } from './md-to-html.pipe';
import { ContactComponent } from './pages/contact/contact.component';
import { FindUsComponent } from './pages/find-us/find-us.component';
import { LandingPageComponent2 } from './pages/landing-page-2/landing-page-2.component';
import { CustomerHomeComponent } from './pages/customer-home/customer-home.component';
import { SearchResultsComponent } from './pages/search-results/search-results.component';
import { LoginComponent } from './pages/login/login.component';
import { PriserComponent } from './pages/priser/priser.component';
import { StartComponent } from './pages/start/start.component';
import { AdminService } from './services/admin.service';
import { ContactService } from './services/contact.service';
import { ContractsService } from './services/contracts.service';
import { DynamicScriptLoaderService } from './services/dynamicScriptLoader.service';
import { EnrollmentService } from './services/enrollment.service';
import { ShuttelbussService } from './services/shuttlebuss.service';
import { StateService } from './services/state.service';
import { MyMonitoringService } from './services/logging.service';
import { BokoingSelectDepartureComponent } from './components/booking-select-departure/booking-select-departure.component';
import { BokoingSelectArrivalComponent } from './components/booking-select-arrival/booking-select-arrival.component';
import { ChatComponent } from './components/chat/chat.component';
import { FaqComponent } from './pages/faq/faq.component';
import { BookingServiceComponent } from './home/checkout/booking-service/booking-service.component';
import { HotelShuttleServiceListComponent } from './home/admin/hotel-shuttle-service-list/hotel-shuttle-service-list.component';
import { HotelShuttleServiceEditComponent } from './home/admin/hotel-shuttle-service-list/hotel-shuttle-service-edit/hotel-shuttle-service-edit.component';
import { EventQueueService } from './services/eventqueue.service';
import { SelfServiceComponent } from './home/self-service/self-service.component';
import { SelfServiceService } from './services/self-service.service';
import { SharedModule } from './shared/shared.module';
import { TUIComponent } from './pages/tui/tui.component';
import { NazarComponent } from './pages/nazar/nazarcomponent';
import { ArlandaparkeringComponent } from './pages/faq/arlandaparkering/arlandaparkering/arlandaparkering.component';
import { AdminStartComponent } from './components/admin-start/admin-start.component';
import { TermsComponent } from './pages/terms/terms.component';
import { ItineraryComponent } from './parkifly-bookings/itinerary/itinerary.component';
import { DateTimeFlightPickerComponent } from './parkifly-bookings/datetimeflight-picker/datetimeflight-picker.component';
import { PasswordStrengthComponent } from './components/password-strength/password-strength.component';
import { SignupComponent } from './components/signup/signup.component';
import { MyConfigService } from './services/my-config.service';
import { BackOffice24Module } from './home/admin/back-office24/back-office24.module';
import { QRCodeComponent } from 'angularx-qrcode';
import { AuthService } from './services/auth.service';
import { SnackbarService } from './services/snackbar.service';
import { OrderParkingService } from './services/orderparking.service';
import { BackOfficeService } from './services/backoffice.service';
import { TopNavbarComponent } from './parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { SimpleWidgetComponent } from './parkifly-bookings/components/widget/simple-widget/widget.component';
import { SimpleSearchSelectComponent } from './parkifly-bookings/components/simple-search-select/simple-search-select.component';
import { AdvancedWidgetComponent } from './parkifly-bookings/components/widget/advanced-widget/advanced-widget.component';
import { ShortTermWidgetComponent } from './parkifly-bookings/components/widget/short-term-widget/short-term-widget.component';
import { ParkAndFlyAdvancedWidgetComponent } from './parkifly-bookings/components/widget/park-and-fly-advanced-widget/park-and-fly-advanced-widget.component';
import { AidenShortTermWidgetComponent } from './parkifly-bookings/components/widget/aiden-short-term-widget/aiden-short-term-widget.component';
import { AidenParkAndFlyAdvancedWidgetComponent } from './parkifly-bookings/components/widget/aiden-park-and-fly-advanced-widget/aiden-park-and-fly-advanced-widget.component';
import { WidgetTestComponent } from './components/widget-test/widget-test.component';
import { ParkingAndTransferPickerModalComponent } from './parkifly-bookings/parking-and-transfer-picker-modal/parking-and-transfer-picker-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginDialogComponent,
    StartComponent,
    NavigationComponent,
    DashboardComponent,
    AppInfoComponent,
    InfoDialogComponent,
    CdkDetailRowDirective,
    PriserComponent,
    ContactComponent,
    DatepickerDirective,
    UsersListComponent,
    AddUserComponent,
    EditUserComponent,
    MdToHtmlPipe,
    ConfirmDeleteComponent,
    ForgotPasswordComponent,
    MySettingsComponent,
    ResetPasswordComponent,
    PasswordStrengthComponent,
    ActivateUserComponent,
    PaymentSuccessComponent,
    PaymentFailureComponent,
    CheckoutPageComponent,
    PaymentBottomsheetComponent,
    DebugModalComponent,
    ReceiptComponent,
    ConditionsComponent,
    ConditionsParkingSizeComponent,
    LandingPageComponent2,
    FindUsComponent,
    LoginComponent,
    BokoingSelectDepartureComponent,
    BokoingSelectArrivalComponent,
    ChatComponent,
    FaqComponent,
    BookingServiceComponent,
    HotelShuttleServiceListComponent,
    HotelShuttleServiceEditComponent,
    SelfServiceComponent,
    TUIComponent,
    NazarComponent,
    ArlandaparkeringComponent,
    AdminStartComponent,
    TermsComponent,
    ItineraryComponent,
    SignupComponent,
    SimpleWidgetComponent,
    AdvancedWidgetComponent,
    ParkAndFlyAdvancedWidgetComponent,
    ShortTermWidgetComponent,
    AidenShortTermWidgetComponent,
    AidenParkAndFlyAdvancedWidgetComponent,
    WidgetTestComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    RouterModule.forRoot(ROUTES, { scrollPositionRestoration: 'enabled' }),
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    LayoutModule,
    NgbModule,
    TimepickerModule,
    DateTimeFlightPickerComponent,
    SimpleSearchSelectComponent,
    BackOffice24Module,
    QRCodeComponent,
    TopNavbarComponent,
    ParkingAndTransferPickerModalComponent,
    CustomerHomeComponent,
    SearchResultsComponent
  ],
  providers: [
    CdkColumnDef,
    DatePipe,
    AdminService,
    AuthService,
    SnackbarService,
    ContactService,
    ContractsService,
    AuthGuard,
    StateService,
    OrderParkingService,
    BackOfficeService,
    ShuttelbussService,
    EnrollmentService,
    DynamicScriptLoaderService,
    MyMonitoringService,
    EventQueueService,
    SelfServiceService,
    MyConfigService,
  ]
})
export class AppModule { }
